/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataCutDisplayMode } from '../models/DataCutDisplayMode';
import type { PricedStatus } from '../models/PricedStatus';
import type { PriceJobMode } from '../models/PriceJobMode';
import type { PricejobResponse } from '../models/PricejobResponse';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PricejobService {

    /**
     * Return pricejob data
     * @returns any Success
     * @throws ApiError
     */
    public static getPricejobData({
        requestBody,
    }: {
        requestBody: {
            limit?: number;
            offset?: number;
            plan?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            companyJob?: Array<number>;
            tags?: Array<number>;
            priced?: PricedStatus;
            search?: Array<string>;
            organizations?: number;
            incumbents?: number;
            grade?: Array<string>;
            payMarket?: Array<string>;
            sort?: Record<string, any>;
            compositeIds?: Array<number>;
            includeJobDescriptions?: boolean;
            jobMappingStatus?: SurveyJobCompanyJobMappingStatus;
        },
    }): CancelablePromise<{
        rows: Array<PricejobResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricejob',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return mass pricejob data
     * @returns any Success
     * @throws ApiError
     */
    public static getMassPricejobData({
        requestBody,
    }: {
        requestBody: {
            activeDataPoint?: string;
            dataCutDisplayMode?: DataCutDisplayMode;
            limit?: number;
            offset?: number;
            plan?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            companyJob?: Array<number>;
            tags?: Array<number>;
            priced?: PricedStatus;
            jobMode?: PriceJobMode;
            search?: Array<string>;
            organizations?: number;
            incumbents?: number;
            grade?: Array<string>;
            payMarket?: Array<string>;
            sort?: Record<string, any>;
            compositeIds?: Array<number>;
            includeJobDescriptions?: boolean;
            jobMappingStatus?: SurveyJobCompanyJobMappingStatus;
        },
    }): CancelablePromise<{
        rows: Array<PricejobResponse>;
        surveyDataCutPaymarketMappings: any[];
        surveyData?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricejob/mass',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return mass pricejob data for single composite
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeMassPricejobData({
        compositeId,
        activeDataPoint,
        dataCutDisplayMode,
    }: {
        /**
         * Composite ID
         */
        compositeId: number,
        /**
         * Active Data Point
         */
        activeDataPoint?: string,
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode?: DataCutDisplayMode,
    }): CancelablePromise<{
        rows: Array<PricejobResponse>;
        surveyDataCutPaymarketMappings: any[];
        surveyData: any[];
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pricejob/mass/{compositeId}',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'activeDataPoint': activeDataPoint,
                'dataCutDisplayMode': dataCutDisplayMode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export cuts selections
     * @returns any Success
     * @throws ApiError
     */
    public static exportCutsSelections({
        requestBody,
    }: {
        requestBody: {
            plan?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            tags?: Array<number>;
            priced?: PricedStatus;
            search?: Array<string>;
            organizations?: number;
            incumbents?: number;
            grade?: Array<string>;
            payMarket?: Array<string>;
            sort?: Record<string, any>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricejob/mass/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export pricejob data
     * @returns any Success
     * @throws ApiError
     */
    public static exportData({
        requestBody,
    }: {
        requestBody: {
            plan?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            companyJob?: Array<number>;
            tags?: Array<number>;
            priced?: PricedStatus;
            search?: Array<string>;
            organizations?: number;
            incumbents?: number;
            grade?: Array<string>;
            payMarket?: Array<string>;
            sort?: Record<string, any>;
            compositeIds?: Array<number>;
            includeJobDescriptions?: boolean;
            jobMappingStatus?: SurveyJobCompanyJobMappingStatus;
            currencyPlanId?: number;
            config?: Array<{
                key?: string;
                title?: string;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pricejob/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return pricejob filters
     * @returns any Success
     * @throws ApiError
     */
    public static getFilters({
        plan,
        jobSubFamily,
        search,
        tagsType,
        rewritesGrade,
    }: {
        /**
         * Plan IDs
         */
        plan?: Array<number>,
        /**
         * Job Sub Family IDs
         */
        jobSubFamily?: Array<number>,
        /**
         * Search
         */
        search?: Array<string>,
        /**
         * Tags Type
         */
        tagsType?: string,
        /**
         * Is Rewrites Grade
         */
        rewritesGrade?: boolean,
    }): CancelablePromise<{
        plans?: any[];
        paymarkets?: any[];
        grades?: any[];
        jobFamilies?: any[];
        jobFamiliesFiltered?: any[];
        jobLevels?: any[];
        companyJobs?: any[];
        companyJobsFiltered?: any[];
        tags?: any[];
        surveys?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pricejob/filters',
            query: {
                'plan': plan,
                'jobSubFamily': jobSubFamily,
                'search': search,
                'tagsType': tagsType,
                'rewritesGrade': rewritesGrade,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
